import axios from "axios";
import authHeader from "@/services/auth-header";
import { ACCOUNT_ENDPOINT, ACCOUNT_LIST_FOR_LANG_ENDPOINT } from "@/constants/endpoints";
import QueryUtils from "@/utils/QueryUtils";
import Page from "@/dto/taxation/Page";
import AccountSummaryForLanguageChange from "@/dto/account/AccountSummaryForLanguageChange";

class AccountService {

    public setPreferredLanguage(userId: number, language: string) {
        return axios.put(`${ACCOUNT_ENDPOINT}/${userId}/language`, { value: language.toUpperCase() }, { headers: authHeader() });
    }

    public getAccountsForLanguageChange(page: number, size: number, searchStr?: string) {
        const queryString = QueryUtils.buildQueryString(["page", page], ["size", size], ["searchStr", searchStr]);
        return axios.get<Page<AccountSummaryForLanguageChange>>(`${ACCOUNT_LIST_FOR_LANG_ENDPOINT}${queryString}`, { headers: authHeader() });
    }

}

export default new AccountService();